//TO DO MAKE VANILLA
var $body = $('.js-body'),
    //body = document.querySelector('.js-body'),
		//thisPage = $body.attr('data-page'),
		site = $body.attr('data-site'),
		//height = $(window).height(),
        body = document.querySelector(".js-body"),
		width = window.innerWidth,
        tickers = document.querySelectorAll(".js-ticker"),
        homepageMenuInner = document.querySelectorAll('.js-home-menu-row'),
        imageCards = document.querySelectorAll('.js-image-card'),
        mixCards = document.querySelectorAll('.js-mix-card'),
        header = document.querySelector('.js-header'),
        openEmailOverlay = document.querySelector(".js-download-button"),
        playVideoBtns = document.querySelectorAll(".js-play-video"),
        videoOverlay = document.querySelector(".js-video-overlay"),
        closeOverlay = document.querySelector(".js-close-video-overlay"),
        menuButton = document.querySelector('.js-menu-button')
;
